import { Component, Input } from '@angular/core';

@Component({
    selector: 'changes-not-saved',
    styleUrls: ['./changes-not-saved.style.scss'],
    templateUrl: './changes-not-saved.template.html',
    standalone: false
})
export class ChangesNotSaved {
  @Input() timeElapsed: string;
  @Input() activityType: string;
  @Input() errorType: string
}